/** Shared shape for Add / Edit employee forms */
export interface EmployeeFormState {
  firstName: string;
  imageUrl: string;
  lastName: string;
  title: string;
  email: string;
  password: string;
  confirmpassword: string;
  roleId: string;
  phoneNumber: string;
  address: string;
  employeeId: string;
  color: string;
  IsDentist: boolean;
  IsBookDentist: boolean;
  image?: File | string | null;
  studies?: string[];
  specialities?: string[];
  languages: string[];
}

/**
 * Calendar doctor colours — Tailwind *-200 pastels.
 * Distinct enough on the week grid; still light enough for slate text.
 */
export const colorOptions = [
  { color: "#bae6fd", name: "Sky Blue" },
  { color: "#fed7aa", name: "Peach" },
  { color: "#bfdbfe", name: "Pale Blue" },
  { color: "#d9f99d", name: "Lime" },
  { color: "#fbcfe8", name: "Pink" },
  { color: "#a7f3d0", name: "Mint" },
  { color: "#fde68a", name: "Amber" },
  { color: "#a5f3fc", name: "Cyan" },
  { color: "#fef08a", name: "Yellow" },
  { color: "#ddd6fe", name: "Lavender" },
] as const;

/** Older picker values (rgba 0.7, then *-100 hex) → current *-200. */
const LEGACY_CALENDAR_COLORS: Record<string, string> = {
  "rgba(102,178,255,0.7)": "#bae6fd",
  "rgba(255,204,153,0.7)": "#fed7aa",
  "rgba(153,204,255,0.7)": "#bfdbfe",
  "rgba(178,255,102,0.7)": "#d9f99d",
  "rgba(255,153,204,0.7)": "#fbcfe8",
  "rgba(204,255,204,0.7)": "#a7f3d0",
  "rgba(255,229,204,0.7)": "#fde68a",
  "rgba(204,229,255,0.7)": "#a5f3fc",
  "rgba(255,255,153,0.7)": "#fef08a",
  "rgba(229,204,255,0.7)": "#ddd6fe",
  "#dbeafe": "#bae6fd",
  "#ffedd5": "#fed7aa",
  "#e0f2fe": "#bfdbfe",
  "#ecfccb": "#d9f99d",
  "#fce7f3": "#fbcfe8",
  "#d1fae5": "#a7f3d0",
  "#fff7ed": "#fde68a",
  "#f0f9ff": "#a5f3fc",
  "#fef9c3": "#fef08a",
  "#ede9fe": "#ddd6fe",
};

function collapseColorKey(color: string): string {
  return color.trim().replace(/\s+/g, "").toLowerCase();
}

/** Map a stored employee color onto the current light palette when possible. */
export function normalizeEmployeeCalendarColor(
  color?: string | null
): string | null {
  if (color == null) return null;
  const raw = String(color).trim();
  if (!raw) return null;
  return LEGACY_CALENDAR_COLORS[collapseColorKey(raw)] ?? raw;
}

export const languageOptions = ["English", "Sinhala", "Tamil"] as const;
